import apiClient from './client';
import { API_ROUTES } from './routes';

export interface TipStats {
  totalEarnings: number;
  todayEarnings: number;
  totalTips: number;
  todayTips: number;
}

export interface Tip {
  id: string;
  amount: number;
  platformFee: number;
  netAmount: number;
  currency: string;
  status: 'pending' | 'succeeded' | 'failed';
  senderName?: string | null;
  message?: string | null;
  createdAt: string;
}

export const tipsApi = {
  async getStats(): Promise<TipStats> {
    const response = await apiClient.get<TipStats>(API_ROUTES.TIPS.STATS);
    return response.data;
  },

  async getTips(limit?: number): Promise<Tip[]> {
    const response = await apiClient.get<Tip[]>(API_ROUTES.TIPS.LIST, {
      params: limit ? { limit } : undefined,
    });
    return response.data;
  },

  async getTip(id: string): Promise<Tip> {
    const response = await apiClient.get<Tip>(API_ROUTES.TIPS.BY_ID(id));
    return response.data;
  },
};
